app.controller('cookieCtrl', [
    '$scope', '$rootScope', '$window', 'appService', function ($scope, $rootScope, $window, appService) {
        var isStudentApp = $window.location.href.indexOf("/student") > 0;
        var isTeacherApp = $window.location.href.indexOf("/teacherapp") > 0;
        var currentCookieState = $window.localStorage.getItem("cookieState");
        var cookieStateIsSupported = (window.tuAndroid != null && window.tuAndroid.setCookieState != null) || (window.webkit != null && window.webkit.messageHandlers != null && window.webkit.messageHandlers["setCookieState"] != null);

    	var vm = this;

        vm.mode = "firstrun";
        vm.functional = true;
        vm.statistics = false;
    	vm.shown = cookieStateIsSupported && (isStudentApp || isTeacherApp) && currentCookieState == null;

        if (cookieStateIsSupported && (isStudentApp || isTeacherApp) && currentCookieState != null) {
            appService.setCookieState(currentCookieState);
        }

        $scope.$on('cookieDialogForceShow', function() {
            vm.mode = "firstrun";
            vm.shown = true;
        });

        $scope.$on('cookieDialogForceShowRemove', function() {
            vm.mode = "remove";
            vm.shown = true;
        });

        vm.hide = function($event) {
            if (vm.mode != "remove") {
                return;
            }
            vm.shown = false;
        }

        vm.onlyFunctional = function() {
            var state = "functional";
            $window.localStorage.setItem("cookieState", state);
            appService.setCookieState(state);

            vm.shown = false;
        }

        vm.accept = function() {
            var state = this.statistics ? "all" : "functional";
            $window.localStorage.setItem("cookieState", state);
            appService.setCookieState(state);

            vm.shown = false;
        }

        vm.toggleChanged = function() {
            var state = this.statistics ? "all" : "functional";
            $window.localStorage.setItem("cookieState", state);
            appService.setCookieState(state);
        }
    }
]);
